var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter" }, [
    _c(
      "button",
      {
        staticClass: "filter-opener",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.openFilter.apply(null, arguments)
          },
        },
      },
      [
        _c("span", [_vm._v("Фильтры")]),
        _vm._v(" "),
        _c("svg", { attrs: { width: "24", height: "24" } }, [
          _c("use", {
            attrs: { "xlink:href": "./assets/sprite.svg#icon-filter" },
          }),
        ]),
        _vm._v(" "),
        _vm.isFilterCounterActive
          ? _c("small", [_vm._v(_vm._s(this.checkedList.length))])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpenerActive,
            expression: "isOpenerActive",
          },
        ],
        staticClass: "filter-container",
      },
      [
        _c("div", { staticClass: "filter-control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isAllBtnChecked,
                expression: "isAllBtnChecked",
              },
            ],
            attrs: { type: "checkbox", id: "all" },
            domProps: {
              checked: Array.isArray(_vm.isAllBtnChecked)
                ? _vm._i(_vm.isAllBtnChecked, null) > -1
                : _vm.isAllBtnChecked,
            },
            on: {
              click: _vm.selectAll,
              change: function ($event) {
                var $$a = _vm.isAllBtnChecked,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isAllBtnChecked = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isAllBtnChecked = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isAllBtnChecked = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "all", tabindex: "0" } }, [
            _vm._v("Все"),
          ]),
        ]),
        _vm._v(" "),
        _vm._l(this.tagList, function (tag, i) {
          return _c(
            "div",
            { key: "tag_" + (i + 1), staticClass: "filter-control" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checkedList,
                    expression: "checkedList",
                  },
                ],
                attrs: {
                  type: "checkbox",
                  id: "tag_" + (i + 1),
                  "data-tag": tag,
                },
                domProps: {
                  value: tag,
                  checked: Array.isArray(_vm.checkedList)
                    ? _vm._i(_vm.checkedList, tag) > -1
                    : _vm.checkedList,
                },
                on: {
                  change: [
                    function ($event) {
                      var $$a = _vm.checkedList,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = tag,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.checkedList = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.checkedList = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.checkedList = $$c
                      }
                    },
                    _vm.emitCheckedList,
                  ],
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "tag_" + (i + 1), tabindex: "0" } }, [
                _vm._v(_vm._s(tag)),
              ]),
            ]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }